export default "/6ca9b194e2a158da211425ad2bf95864.jpg";